import axios from 'axios';
import Chartkick from 'chartkick';
import Chart from 'chart.js';
import persistActiveTab from './persist_active_tab';
import 'hammerjs';
import 'chartjs-plugin-zoom';

Chartkick.use(Chart);

const startDate = moment();
const endDate = moment();

const formatDate = function (start, end) {
  $('#production_per_order_daterange span')
    .html(`${start.format('MMMM D, YYYY')} - ${end.format('MMMM D, YYYY')}`)
    .trigger('change');
  $('#top_finished_products_daterange span')
    .html(`${start.format('MMMM D, YYYY')} - ${end.format('MMMM D, YYYY')}`)
    .trigger('change');
  $('#consumption_variation_per_order_daterange span')
    .html(`${start.format('MMMM D, YYYY')} - ${end.format('MMMM D, YYYY')}`)
    .trigger('change');
};

const resetChartZoom = function (chartId) {
  Chartkick.charts[chartId].chart.resetZoom();
};

const updateProductionPerOrderChart = async () => {
  const chart = Chartkick.charts['production-per-order-chart'];
  const daterangeSpan = document.querySelector(
    '#production_per_order_daterange span'
  );
  const params = {
    start_at: moment(
      daterangeSpan.textContent.split(' - ')[0],
      'MMMM D, YYYY'
    ).format(),
    end_at: moment(
      daterangeSpan.textContent.split(' - ')[1],
      'MMMM D, YYYY'
    ).format(),
  };
  try {
    const res = await axios.get('/dashboard/production_per_order.json', {
      params,
    });
    chart.updateData(res.data);
  } catch (error) {
    console.log(error);
  }
};

const updateTopFinishedProductsChart = async () => {
  const chart = Chartkick.charts['top-finished-products-chart'];
  const daterangeSpan = document.querySelector(
    '#top_finished_products_daterange span'
  );
  const params = {
    start_at: moment(
      daterangeSpan.textContent.split(' - ')[0],
      'MMMM D, YYYY'
    ).format(),
    end_at: moment(
      daterangeSpan.textContent.split(' - ')[1],
      'MMMM D, YYYY'
    ).format(),
  };
  try {
    const res = await axios.get('/dashboard/top_finished_products', {
      params,
    });
    chart.updateData(res.data);
  } catch (error) {
    console.log(error);
  }
};

document.addEventListener('turbolinks:load', function () {
  // Persist active dasboard tab in LocalStorage
  persistActiveTab();

  // Format daterange of charts
  $('.dashboard_chart_predefined_daterange').daterangepicker(
    {
      startDate,
      endDate,
      locale: {
        applyLabel: 'Aplicar',
        cancelLabel: 'Cancelar',
        customRangeLabel: 'Rango personalizado',
      },
      showDropdowns: true,
      ranges: {
        Hoy: [moment().startOf('day'), moment().endOf('day')],
        Ayer: [
          moment().subtract(1, 'days').startOf('day'),
          moment().subtract(1, 'days').endOf('day'),
        ],
        'Últimos 7 días': [
          moment().subtract(6, 'days').startOf('day'),
          moment().endOf('day'),
        ],
        'Últimos 30 días': [
          moment().subtract(29, 'days').startOf('day'),
          moment().endOf('day'),
        ],
        'Este mes': [moment().startOf('month'), moment().endOf('month')],
        'Mes pasado': [
          moment().subtract(1, 'month').startOf('month'),
          moment().subtract(1, 'month').endOf('month'),
        ],
      },
    },
    formatDate
  );
  formatDate(startDate, endDate);

  // Dynamically update chart when a date range is selected
  $('#production_per_order_daterange span').on(
    'change',
    updateProductionPerOrderChart
  );
  $('#top_finished_products_daterange span').on(
    'change',
    updateTopFinishedProductsChart
  );

  // Reset chart zoom when clicking reset button
  $('#production-per-order-zoom-reset-btn').on('click', function () {
    resetChartZoom('production-per-order-chart');
  });
  $('#movements-per-day-zoom-reset-btn').on('click', function () {
    resetChartZoom('movements-per-day-chart');
  });
  $('#top-finished-products-zoom-reset-btn').on('click', function () {
    resetChartZoom('top-finished-products-chart');
  });
});
